import { render, staticRenderFns } from "./RelatorioFechamentoVendedores.vue?vue&type=template&id=a0445582&scoped=true"
import script from "./RelatorioFechamentoVendedores.vue?vue&type=script&lang=ts"
export * from "./RelatorioFechamentoVendedores.vue?vue&type=script&lang=ts"
import style0 from "./RelatorioFechamentoVendedores.vue?vue&type=style&index=0&id=a0445582&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0445582",
  null
  
)

export default component.exports